import { getDefaultMultiStrikeColorPalette } from './multiStrikeColorPalettes'

const defaultPalette = getDefaultMultiStrikeColorPalette('light')

export const callColorPallet = defaultPalette.callColors
export const putColorPallet = defaultPalette.putColors
export const callColorCumulative = defaultPalette.callCumulative
export const putColorCumulative = defaultPalette.putCumulative
export const primarySecColorLightTheme = '#3a3a3a3b'
export const primarySecColorDarkTheme = '#e0e0e03b'